import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers';

/* eslint-disable */
const composeEnhancers = typeof window !== 'undefined'
&& window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  : compose;
/* eslint-enable */

export default function configureStore(initialState) {
  const middleware = [thunk];
  return createStore(
    reducers,
    initialState,
    composeEnhancers(
      applyMiddleware(...middleware),
    ),
  );
}
